import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { standardGetHttpOptions, standardHttpOptions } from '@models';
import { LoadingService } from '@services/loading.service';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { KigSettings, KIG_SETTINGS } from '../../../settings/kig-settings';
import { UserService } from '@services/user.service';
import {  catchError, finalize, map } from 'rxjs/operators';
import { of } from 'rxjs';
import saveAs from 'file-saver';


@Injectable()
export class FileStorageService {
  public standardHttpOptionsWithUser: any;

  private apiUrl: string;

  constructor(private http: HttpClient,
              private loadingService: LoadingService,
              @Inject(KIG_SETTINGS) private settings: KigSettings,
              private userService: UserService) {
    this.apiUrl = this.settings.apiUrl;
  }

  buildStandardHttpOptionsWithUser(username: string) {
    this.standardHttpOptionsWithUser = {
      withCredentials: true,
      headers: new HttpHeaders({
        ['Content-Type']: 'application/json',
        username
      })
    };
  }


  public getListOfFilesForSource(sourceId: string): Observable<string[]> {
    //this.loadingService.setMessage('Loading storage list ...');
    return this.http.get<string[]>(`${ this.apiUrl }/fileStorage/fileList/${sourceId}`, standardGetHttpOptions).pipe(
      catchError(this.handleError)); //,
      //finalize(() => this.loadingService.clearMessage())
      //);
  }


  public deleteFileFromStorage(sourceId: string, filename: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requestOptions: Object = {
      headers: headers,
      responseType: 'text'
    }

    this.loadingService.setMessage('Deleting file ...');
    return this.http.post(`${ this.apiUrl }/fileStorage/deleteFile/${sourceId}`, JSON.stringify(filename), requestOptions).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }


  public uploadFileToStorage(sourceId: string, formData: FormData): Observable<any> {
    let params = new HttpParams();
    var httpOptions = {
      params: params
    };
    this.loadingService.setMessage('Uploading file ...');
    return this.http.post(`${ this.apiUrl }/fileStorage/uploadFile/${sourceId}`, formData, httpOptions).pipe(
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }


  public downloadFileFromStorage(sourceId: string, filename: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const requestOptions: Object = {
      headers: headers,
      responseType: 'blob'
    }

    this.loadingService.setMessage('Downloading file ...');
    return this.http.post(`${ this.apiUrl }/fileStorage/downloadFile/${sourceId}`, JSON.stringify(filename), requestOptions).pipe(
      map((response: any) => {
        const blob = new Blob([response], {
          type: 'application/octet-stream'
        });
        saveAs(blob, filename);
      }),
      catchError(this.handleError),
      finalize(() => this.loadingService.clearMessage())
    );
  }


  private handleError(error: any) {
    if (error.status === 404) {
      return of(null);
    }
    return throwError(() => error);
  }
}
